import React, { useState } from 'react';
// import { useSelector } from 'react-redux';

import notaire from './../../../assets/images/svg/004-A-notaire.png';
import securitesociale from './../../../assets/images/svg/004-A-securitesocial.png';
import banque from './../../../assets/images/svg/004-A-banque.svg';
import mutuelle from './../../../assets/images/svg/004-A-mutuelle.svg';
import assurance from './../../../assets/images/svg/100-assurance.svg';
import fournisseureau from './../../../assets/images/svg/004-A-fournisseureau.svg';
import fournisseurelectricite from './../../../assets/images/svg/004-A-fournisseurelectricite.svg';
import telephonemobile from './../../../assets/images/svg/004-A-telephonemobile.svg';
import centreimpots from './../../../assets/images/svg/004-A-dgfip.png';

import sport from './../../../assets/images/svg/004-B-sport.svg';
import internet from './../../../assets/images/svg/004-B-internet.svg';
import loisirs from './../../../assets/images/svg/004-B-loisirs.svg';
import voitures from './../../../assets/images/svg/004-B-voiture.svg';
import transport from './../../../assets/images/svg/004-B-transport.svg';
import entretienmaison from './../../../assets/images/svg/004-B-entretienmaison.svg';
import securite from './../../../assets/images/svg/004-B-securite.svg';
import soinesthetique from './../../../assets/images/svg/004-B-soinesthetique.svg';
import domicile from './../../../assets/images/svg/004-B-domicile.svg';
import musique from './../../../assets/images/svg/004-B-musique.svg';
import cartepaiment from './../../../assets/images/svg/004-B-cartepaiment.svg';
import multimedia from './../../../assets/images/svg/004-B-multimedia.svg';
import tech from './../../../assets/images/svg/004-B-tech.svg';
import tv from './../../../assets/images/svg/004-B-tv.svg';
import solidaire from './../../../assets/images/svg/004-B-solidaire.svg';
import autres from './../../../assets/images/svg/004-B-autres.svg';

import reseauxsociaux from './../../../assets/images/svg/104-social-media.svg';
import loisir from './../../../assets/images/svg/029-football-ball.svg';
import pet from './../../../assets/images/svg/028-pet-food.svg';
import mobile from './../../../assets/images/svg/024-furniture.svg';
import personnes from './../../../assets/images/svg/024-account.svg';
import duo from './../../../assets/images/svg/088-duo.svg';

export const EnvoisProfile = () => {
	// const router = useSelector(state => state.router);
	//We should get it from backend!
	function service(title, icon, progress) { return { title: title, icon: icon, progress: (progress === undefined ? 0 : progress) } };
	function doc(firstTitle, secondTitle, num, actions) { return { firstTitle: firstTitle, secondTitle: secondTitle, num: num, actions: actions } };
	const [userServices, setUserServices] = useState([
		service('notaire', notaire, 100), service('sport', sport, 100), service('internet', internet, 0), service('fournisseur d\'électricité', fournisseurelectricite, 100),
		service('téléphone mobile', telephonemobile, 100), service('banque', banque, 100), service('multimedia', multimedia, 100), service('dissolution du pacs', securitesociale, 100),
		service('centre des impôts', centreimpots, 100), service('musique', musique, 100), service('mutuelle', mutuelle, 100), service('voiture', voitures, 100),
		service('assurance', assurance, 100), service('fournisseur d\'eau', fournisseureau, 100), service('loisirs', loisirs, 100), service('titre de transport', transport, 100),
		service('entretien maison', entretienmaison, 100), service('sécurité', securite, 100), service('SOIN ET ESTHETIQUE', soinesthetique, 100), service('Services a domicile', domicile, 100),
		service('CARTE DE PAIEMENT', cartepaiment, 100), service('Technology', tech, 100), service('TÉLÉVISION', tv), service('solidarité', solidaire, 100),
		service('autres', autres, 100), service('reseaux sociaux', reseauxsociaux, 100), service('loisirs', loisir), service('animaux', pet, 100),
		service('MATERIEL / MOBILE', mobile), service('personnes', personnes, 100), service('duo', duo, 100)
	]);
	const [userDocuments, setUserDocuments] = useState([doc('documents', 'personnels', 0, 4), doc('documents', 'mandataire', 0, 3), doc('démarches', 'communes', 3, 10), doc('démarches', 'personnalisées', 4, 20)]);

	return (
		<div className="modal fade px-0" id="EnvoisProfile" aria-labelledby="EnvoisProfileLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-dialog-scrollable container-modal">
				<div className="modal-content pr-4 bg-light">
					<header className="modal-header flex-column pb-0 mr-n4">
						<div className="alert bg-white rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0 mb-lg-3">
							<h1 className="sr-only visually-hidden">User Envois</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-warning text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="EnvoisProfileLabel">Suivi des envois</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0 o-60--hover" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
						<nav className="navbar navbar-expand-lg sticky-top bg-light w-100 mb-1 pl-0 pr-sm">
							<h1 className="sr-only visually-hidden">Envois: navigation</h1>
							<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#trier" aria-controls="trier" aria-expanded="false" aria-label="Toggle navigation">
								<span className="btn-alert-primary eva eva-funnel-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
								<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Trier par</span>
							</button>
							<div className="collapse navbar-collapse mt-2 mt-lg-0" id="trier">
								<div className="flex-column w-100">
									<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
										<div className="col-12 col-lg">
											<div className="row g-1 gx-lg-2 align-items-lg-center">
												<div className="col flex-row text-lg-truncate">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-60 o-100--hover" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-60 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 text-left fs-3 font-weight-bold ls-1 my-auto text-truncate"><span className="d-md-none d-xl-inline-block">Numéro du </span> processus</div>
												</div>
												<div className="col flex-row text-lg-truncate">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-60 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 text-left fs-3 font-weight-bold ls-1 my-auto text-truncate text-primary"><span className="d-md-none d-xl-inline-block">Nom du </span> mandataire</div>
												</div>
												<div className="col flex-row text-lg-truncate">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-60 o-100--hover" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-60 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 text-left fs-3 font-weight-bold ls-1 my-auto text-truncate">Nombre de page</div>
												</div>
												<div className="col col-xl flex-row text-lg-truncate">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-60 o-100--hover" type="button" >
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-60 o-100--hover" type="button" >
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 text-left fs-3 font-weight-bold ls-1 my-auto text-truncate">Numéro du recommandé </div>
												</div>
												<div className="col flex-row text-lg-truncate">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-60 o-100--hover" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-60 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 text-left fs-3 font-weight-bold ls-1 my-auto text-truncate">Date d’envoi </div>
												</div>
												<div className="col col-xl-auto flex-row text-lg-truncate">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-60 o-100--hover" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-60 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 text-left fs-3 font-weight-bold ls-1 my-auto text-truncate">Responsable <span className="d-md-none d-lg-inline-block"> traitement</span> </div>
												</div>
											</div>
										</div>
										<div className="col-12 col-lg-auto ml-auto">
											<div className="sr-only visually-hidden">Actions</div>
											<div className="w-lg-4"></div>
										</div>
									</div>
								</div>
							</div>
						</nav>
					</header>
					<section className="modal-body scroll-default py-0 pr-3">
						<form className="block grid-sm grid-md-2 grid-lg-1 gy-lg-0">
							<h1 className="sr-only visually-hidden">Envois: list</h1>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>											
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>											
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>											
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card p-2 mt-1 border-light">
								<div className="row g-1 gx-lg-2 gy-md-0 align-items-center p-2 py-lg-0">
									<div className="col-12 col-lg">
										<div className="row g-1 gx-lg-2 align-items-lg-center">
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate text-muted">Numéro du processus</div>
											</div>
											<div className="col order-first order-lg-0">
												<div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-lg-truncate">Nom du mandataire</div>
											</div>
											<div className="col-12 col-lg text-lg-truncate">
												<div className="h5 ls-1 my-auto text-lg-truncate">Nombre de page</div>
											</div>
											<div className="col col-lg-auto text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto text-gray text-lg-truncate">Numéro du recommandé</div>
											</div>
											<div className="col text-right text-lg-left text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-auto">Date d’envoi</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0 mt-md-xs" />
											</div>
											<div className="col-12 col-md text-lg-truncate">
												<div className="h5 ls-1 my-auto container-press ml-lg-auto text-lg-truncate">Responsable traitement </div>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-none">
										<hr className="my-0 my-md-xs" />
									</div>
									<div className="col-12 col-lg-auto ml-auto">
										<div className="w-md-4"></div>
										<div className="flex-row justify-content-md-end">
											<button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-auto" data-toggle="tooltip" title="Modifier le partenaire" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
												<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</form>
					</section>
					<div className="modal-footer py-3 mr-n4 bg-white mt-4">
						<button type="button" className="btn btn-faded" data-dismiss="modal">Fermer</button>
					</div>
				</div>
			</div>
		</div>
	)	
}